import React from "react";
import { Stack } from "@mui/material";
import { Images } from "../../../assets/common";

const YOUTUBE_ICON =
  "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='white'><path d='M23.5 6.2a3 3 0 0 0-2.1-2.1C19.5 3.6 12 3.6 12 3.6s-7.5 0-9.4.5A3 3 0 0 0 .5 6.2 31 31 0 0 0 0 12a31 31 0 0 0 .5 5.8 3 3 0 0 0 2.1 2.1c1.9.5 9.4.5 9.4.5s7.5 0 9.4-.5a3 3 0 0 0 2.1-2.1A31 31 0 0 0 24 12a31 31 0 0 0-.5-5.8zM9.6 15.6V8.4l6.2 3.6-6.2 3.6z'/></svg>";

export default function ProfileSocialLinks({ twitter, instagram, tiktok, youtube }) {
  if (!twitter && !instagram && !tiktok && !youtube) return null;

  const links = [
    {
      url: twitter,
      icon: Images.twitter_t,
      alt: "Twitter",
      prefix: "https://www.twitter.com/",
    },
    {
      url: instagram,
      icon: Images.instagram,
      alt: "Instagram",
      prefix: "https://www.instagram.com/",
    },
    {
      url: tiktok,
      icon: Images.tiktok,
      alt: "TikTok",
      prefix: "https://www.tiktok.com/",
    },
    {
      url: youtube,
      icon: YOUTUBE_ICON,
      alt: "YouTube",
      // Accepts a handle, @handle, or a full channel URL.
      prefix: "https://www.youtube.com/@",
    },
  ].filter((l) => l.url);

  return (
    <Stack direction="row" sx={{ gap: "6px" }}>
      {links.map((link) => (
        <a
          key={link.alt}
          href={
            link.url.includes("https://") ? link.url : `${link.prefix}${link.url.replace(/^@/, "")}`
          }
          target="_blank"
          rel="noopener noreferrer"
          style={{
            width: 34,
            height: 34,
            borderRadius: 8,
            background: "rgba(255,255,255,0.04)",
            border: "1px solid rgba(255,255,255,0.06)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transition: "all 0.2s ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = "#FFEE20";
            e.currentTarget.style.borderColor = "#FFEE20";
            e.currentTarget.querySelector("img").style.filter =
              "brightness(0)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = "rgba(255,255,255,0.04)";
            e.currentTarget.style.borderColor = "rgba(255,255,255,0.06)";
            e.currentTarget.querySelector("img").style.filter = "none";
          }}
        >
          <img
            src={link.icon}
            height={15}
            width={15}
            alt={link.alt}
            style={{ opacity: 0.5, transition: "all 0.2s ease" }}
          />
        </a>
      ))}
    </Stack>
  );
}
